export default __webpack_public_path__ + "static/11x17_AirQualityPartnershipActivitySheet-10d7d89decbdee5477df09f1826dcd03.pdf";